import React from 'react'
import Web3Banner from '../components/Web3Banner'
import Web3ServicesComponent from '../components/Web3Services'

const Web3Services = () => {
  return (
    <>
    <Web3Banner />
    <Web3ServicesComponent />
    </>
  )
}

export default Web3Services